/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

/**** Footer Newsletter STARTS *****/
  $(document).ready(function () {
    //alert('aa');
    var $form = $('#mc-embedded-subscribe-form')
    if ($form.length > 0) {
      $('form#mc-embedded-subscribe-form button#mc-embedded-subscribe').bind('click', function (event) {
        if (event) event.preventDefault()
        register($form)
      })
    }
  })

  function register($form) {
    $('#mc-embedded-subscribe').val('Sending...');
    $.ajax({
      type: $form.attr('method'),
      url: $form.attr('action'),
      data: $form.serialize(),
      cache: false,
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      error: function (err) { alert('Could not connect to the registration server. Please try again later.') },
      success: function (data) {
        $('#mc-embedded-subscribe').val('subscribe')
        if (data.result === 'success') {
          // Yeahhhh Success
          console.log(data.msg)
          //$('#mce-EMAIL').css('borderColor', '#ffffff')
          $('.mailchimpfrm').css('display', 'none');
          $('#subscribe-result').html('<p class="note form-success">Thank you</p><br /><p id="disccodes">To complete the subscription process, please click the link in the email we just sent you.</p></div>')
          //$('#mce-EMAIL').val('')
        } else {
          // Something went wrong, do something to notify the user.
          console.log(data.msg)
          //$('#mce-EMAIL').css('borderColor', '#ff8282')
          //$('#subscribe-result').css('color', '#ff8282')
          //$('#subscribe-result').html('<p>' + data.msg.substring(4) + '</p>')
        }
      }
    })
  };
  
  $(document).ready(function () {
    //alert('aa');
    var $form = $('#mc-embedded-subscribe-form-italian')
    if ($form.length > 0) {
      $('form#mc-embedded-subscribe-form-italian button#mc-embedded-subscribe-italian').bind('click', function (event) {
        if (event) event.preventDefault()
        italianregister($form)
      })
    }
  })

  function italianregister($form) {
    $('#mc-embedded-subscribe-italian').val('Sending...');
    $.ajax({
      type: $form.attr('method'),
      url: $form.attr('action'),
      data: $form.serialize(),
      cache: false,
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      error: function (err) { alert('Could not connect to the registration server. Please try again later.') },
      success: function (data) {
        $('#mc-embedded-subscribe-italian').val('subscribe')
        if (data.result === 'success') {
          // Yeahhhh Success
          console.log(data.msg)
          //$('#mce-EMAIL').css('borderColor', '#ffffff')
          $('.mailchimpfrm').css('display', 'none');
          $('#italian-subscribe-result').html('<p class="note form-success">Thank you</p><br /><p id="disccodes">To complete the subscription process, please click the link in the email we just sent you.</p></div>')
          //$('#mce-EMAIL').val('')
        } else {
          // Something went wrong, do something to notify the user.
          console.log(data.msg)
          //$('#mce-EMAIL').css('borderColor', '#ff8282')
          //$('#subscribe-result').css('color', '#ff8282')
          //$('#subscribe-result').html('<p>' + data.msg.substring(4) + '</p>')
        }
      }
    })
  };
  /**** Footer Newsletter ENDS *****/
  
  /****Newsletter Popup STARTS*****/  
  $(document).ready(function () {
    //alert('aa');
    var $form = $('#mc-embedded-subscribe-formpopup')
    if ($form.length > 0) {
      $('form#mc-embedded-subscribe-formpopup button#mc-embedded-subscribepopup').bind('click', function (event) {
        if (event) event.preventDefault()
        popupregister($form)
      })
    }
  })

  function popupregister($form) {
    $('#mc-embedded-subscribepopup').val('Sending...');
    $.ajax({
      type: $form.attr('method'),
      url: $form.attr('action'),
      data: $form.serialize(),
      cache: false,
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      error: function (err) { alert('Could not connect to the registration server. Please try again later.') },
      success: function (data) {
        $('#mc-embedded-subscribepopup').val('subscribe')
        if (data.result === 'success') {
          // Yeahhhh Success
          console.log(data.msg)
          //$('#mce-EMAIL').css('borderColor', '#ffffff')
          $('.mailchimpfrmpopup').css('display', 'none');
          $('#subscribe-resultpopup').html('<p class="note form-success">Thank you</p><br /><p id="disccodes">To complete the subscription process, please click the link in the email we just sent you.</p></div>')
          //$('#mce-EMAIL').val('')
        } else {
          // Something went wrong, do something to notify the user.
          console.log(data.msg)
          //$('#mce-EMAIL').css('borderColor', '#ff8282')
          //$('#subscribe-result').css('color', '#ff8282')
          //$('#subscribe-result').html('<p>' + data.msg.substring(4) + '</p>')
        }
      }
    })
  };
  $(document).ready(function () {
    //alert('aa');
    var $form = $('#mc-embedded-subscribe-formpopup-italian')
    if ($form.length > 0) {
      $('form#mc-embedded-subscribe-formpopup-italian button#mc-embedded-subscribepopup-italian').bind('click', function (event) {
        if (event) event.preventDefault()
        italianpopupregister($form)
      })
    }
  })

  function italianpopupregister($form) {
    $('#mc-embedded-subscribepopup-italian').val('Sending...');
    $.ajax({
      type: $form.attr('method'),
      url: $form.attr('action'),
      data: $form.serialize(),
      cache: false,
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      error: function (err) { alert('Could not connect to the registration server. Please try again later.') },
      success: function (data) {
        $('#mc-embedded-subscribepopup-italian').val('subscribe')
        if (data.result === 'success') {
          // Yeahhhh Success
          console.log(data.msg)
          //$('#mce-EMAIL').css('borderColor', '#ffffff')
          $('.mailchimpfrmpopup').css('display', 'none');
          $('#italian-subscribe-resultpopup').html('<p class="note form-success">Thank you</p><br /><p id="disccodes">To complete the subscription process, please click the link in the email we just sent you.</p></div>')
          //$('#mce-EMAIL').val('')
        } else {
          // Something went wrong, do something to notify the user.
          console.log(data.msg)
          //$('#mce-EMAIL').css('borderColor', '#ff8282')
          //$('#subscribe-result').css('color', '#ff8282')
          //$('#subscribe-result').html('<p>' + data.msg.substring(4) + '</p>')
        }
      }
    })
  };
  /****Newsletter Popup ENDS *****/

  /**
   * EDITED by HS - 15 Feb 2019
   * The theme allows for a newsletter popup to show only once per user.
   *
   * The theme JS uses localStorage to determine if the newsletter popup
   * has been opened. When selecting the Italian language site via Langify app,
   * the popup was opening on every page, and ignoring localStorage.
   *
   * As merchant wanted multiple Mailchimp forms, a developer added the 
   * following custom code. This led to the popup CSS showing as visible on the
   * Italian site for every page despite the localStorage.
   * 
   * We will add a new localStorage setting called themePopupItaly. This ensures
   * that if the user visits the UK site and sees the UK popup - if they change
   * to the Italian site, they'll see the Italian popup. We can then ensure that
   * Italian users only see the popup once.
   *
   * 1. We add a conditional based on localStorage `themePopupItaly`. If it does
   *    not exist, then we open the popup.
   * 2. We set the localStorage themePopupItaly to 'true' if it has been viewed
   *    so it only shows once.
   */
  
  $(window).load(function() {    
    var selectedCountry = $('#ly-languages-switcher').children("option:selected").val();
	//alert("You have selected the country - " + selectedCountry);
    if(selectedCountry == "ly59894" && localStorage.getItem('themePopupItaly') === null) /* [1] */ {
      $('#mc-embedded-subscribe-form').hide();
      $('#mc-embedded-subscribe-formpopup').hide();
      $('#mc-embedded-subscribe-form-italian').show();
      $('#mc-embedded-subscribe-formpopup-italian').show();
      setTimeout(
      function() {
        $(".NewsletterPopup").css({"opacity": "1", "visibility": "visible", "transform": "translateY(0px)"});
      }, 5000);

      localStorage.setItem('themePopupItaly', 'true'); /* 2 */

    } else {
      $('#mc-embedded-subscribe-form').show();
      $('#mc-embedded-subscribe-formpopup').show();
      $('#mc-embedded-subscribe-form-italian').hide();
      $('#mc-embedded-subscribe-formpopup-italian').hide();
    }
    
    $('.NewsletterPopup__Close').click(function() {
      $(".NewsletterPopup").css({"opacity": "0", "visibility": "hidden", "transform": "translateY(25px)"});
    });
  });

(function() {
    var touchingCarousel = false,
      touchStartCoords;

    document.body.addEventListener('touchstart', function(e) {
      if (e.target.closest('.flickity-slider')) {
        touchingCarousel = true;
      } else {
        touchingCarousel = false;
        return;
      }

      touchStartCoords = {
        x: e.touches[0].pageX,
        y: e.touches[0].pageY
      }
    });

    document.body.addEventListener('touchmove', function(e) {
      if (!(touchingCarousel && e.cancelable)) {
        return;
      }

      var moveVector = {
        x: e.touches[0].pageX - touchStartCoords.x,
        y: e.touches[0].pageY - touchStartCoords.y
      };

      if (Math.abs(moveVector.x) > 7)
        e.preventDefault()

    }, {passive: false});
  })();


$('.ad_to_cart_coll').click(function(){    
  var ID = $(this).attr("data-var_id");
  addItemToCart( ID, 1);    // paste your id product number
  $('.cart_dr').trigger( "click" );
});
function addItemToCart(variant_id, qty) {
  data = {
    "id": variant_id,
    "quantity": qty
  }
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function() { 
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true  //this code is for prestige theme, is to refresh the cart
      }));
    }   
    
  }); 
 
}


$(document).ready(function () {
  $('.Product_main').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.Product_Nav'
  });
  $('.Product_Nav').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.Product_main',
    dots: false,
    arrows: true,
    centerMode: false,
    focusOnSelect: true,
      infinite: true,
     responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 4
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 3
      }
    }
  ]
  });

});